function titleCase(str) {
  if (str) {
    return str.replace(
      /\w\S*/g,
      txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
  }
  return "";
}

export function numberWithCommas(x) {
  if (!x) return "0";
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatName(s) {
  if (s === null) {
    return "";
  }
  return titleCase(s.replace(/-/g, " ")).replace("ç", "c");
}

export function perc(number) {
  return `${(number * 100).toFixed(2)}%`;
}

export function abbreviateNumber(num, fixed = 0) {
  if (num === null || num === undefined) return null;
  if (num === 0) return "0";

  const b = num.toPrecision(2).split("e"); // get power
  const k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3); // floor at decimals, ceiling at trillions
  const c =
    k < 1
      ? num.toFixed(0 + fixed)
      : (num / Math.pow(10, k * 3)).toFixed(1 + fixed); // divide by power
  const d = c < 0 ? c : Math.abs(c); // enforce -0 is 0
  const e = d + ["", "K", "M", "B", "T"][k]; // append power

  return e;
}

const FORMATS = {
  perCapita100k: x => numberWithCommas(Math.round(x * 100000)),
  noZero: x => (x === 0 ? "" : x),
  perc: x =>
    // if (typeof x !== "number") {
    // return "-";
    // }
    perc(x),
  percAlt: x =>
    // for data where the percent values are already in a 0-100 format
    // if (typeof x !== "number") {
    // return "-";
    // }

    perc(x / 100),

  numberWithCommas: x => numberWithCommas(x),
};

export function getFormatting(format) {
  if (typeof format === "string") {
    return FORMATS[format];
  }

  if (typeof format === "object") {
    return x => {
      if (format[x] !== undefined) {
        return format[x];
      }

      if (format.DEFAULT_FORMATTER) {
        return FORMATS[format.DEFAULT_FORMATTER](x);
      }

      return x;
    };
  }

  return format;
}

export const defaultColumns = {
  rank: {
    header: "Rank",
    field: "rank",
  },
  state: {
    header: "State",
    field: "State",
  },
  flag: {
    header: "Flag",
    field: "State",
    format: x => x,
  },
};
